module.exports = __webpack_public_path__ + "static/media/image-3.1ba04a6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-3.jpg
// module id = 280
// module chunks = 0